const config = {
  apiGateway: {
    URL: "https://nl0kyu32lg.execute-api.ca-central-1.amazonaws.com/v1/",
    AUTH: "https://04wng7wjpi.execute-api.ca-central-1.amazonaws.com/v1/",
    REGION: "ca-central-1"
  },
  defaultLanguage: "en",
  sso_enabled: true,
  sso_config: {
            auth_url: "wapw-prod.auth.ca-central-1.amazoncognito.com",
            identity_provider: "WAPW-PROD-AD",
            scope: "openid+aws.cognito.signin.user.admin",
            grant_type: "authorization_code",
            client_id: "fapcpnhc5gtvmu5p4rdja1995",
            redirect_uri: "https://advisorconnect.wellingtonaltus.digital/authorize",
        },
  dast_config: {enabled: false},
  canadaPostApiKey: "RC21-DM77-CJ35-NB14",
  fef_ui_version: "2.0.62.1-tier2"
}

var siteConfig = {
  title: "Wellington Altus",
  fourlyticsId: false,
  fourlyticsScreenRecording: false
};

var componentConfig = {
  
};

export {config, siteConfig, componentConfig}
